import jaBlogPosts from "./blogPosts.json";
import jaBghUrteile from "./bghUrteile.json";
import jaCalculator from "./calculator.json";
import jaCommon from "./common.json";
import jaDialogs from "./dialogs.json";
import jaExpertise from "./expertise.json";
import jaExpertiseSolutions from "./expertiseSolutions.json";
import jaFaqs from "./faqs.json";
import jaFooter from "./footer.json";
import jaHome from "./home.json";
import jaJudgmentsLanding from "./judgmentsLanding.json";
import jaLandingpages from "./landingpages.json";
import jaNav from "./nav.json";
import jaReferences from "./references.json";
import jaSolvingTax from "./solvingTax.json";
import jaTeam from "./team.json";

/** Merged onto `deCatalog` via `mergeDeep` in `buildCatalog` (no `expertiseCity` — inherits DE). */
export const jaMessageOverlay = {
  nav: jaNav,
  footer: jaFooter,
  home: jaHome,
  common: jaCommon,
  dialogs: jaDialogs,
  expertise: jaExpertise,
  blogPosts: jaBlogPosts,
  expertiseSolutions: jaExpertiseSolutions,
  team: jaTeam,
  references: jaReferences,
  landingpages: jaLandingpages,
  solvingTax: jaSolvingTax,
  bghUrteile: jaBghUrteile,
  faqs: jaFaqs,
  calculator: jaCalculator,
  judgmentsLanding: jaJudgmentsLanding,
} as const;
